import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import CreateHpDeviceProvider from "./baseProviders/createHpDeviceProvider"
import useContinueHpDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueHpDeviceDraft"

interface IContinueHpDeviceVersionUrlParams {
    deviceRef: string
}

interface IContinueHpDeviceVersionProviderProps {
    children: ReactNode
}

const ContinueHpDeviceVersionProvider = ({
    children,
}: IContinueHpDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueHpDeviceVersionUrlParams
    >() as IContinueHpDeviceVersionUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueVersionError,
        attachmentUUID,
    } = useContinueHpDeviceDraft(urlDeviceRef)

    return (
        <CreateHpDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueVersionError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={urlDeviceRef}
            canEditManufacturer={false}
        >
            {children}
        </CreateHpDeviceProvider>
    )
}

export default ContinueHpDeviceVersionProvider
